<template lang="pug">
  .height-100
    .contenedor-box
      .box
        form(v-if="!estoySiendoReemplazado")
          .flex.fdr.space-evenly
            .field
              label.label(for="reemplazante") Reemplazante
              .control
                .input-container
                  input.input(
                    type="number",
                    v-model="codigoReemplazante"
                    @click="mostrarBusquedaReemplazante = true"
                  )
                  .erase-data(@click="codigoReemplazante = ''")
                    .icon
                      .fa.fa-times
                transition(name="fade-quick")
                  .pop-over(
                      v-if="mostrarBusquedaReemplazante"
                    )
                      lookup-small-empleado(
                        @selected="seleccionarReemplazante"
                        @close="mostrarBusquedaReemplazante = false"
                        :codigo="codigoReemplazante"
                      )

            .field
              label.label(for="fechaInicio") Fecha de Inicio
              .control
                input.input(type="date", v-model="fechaInicio", :min="getTodayDate()")
            .field
              label.label(for="fechaFin") Fecha de Fin
              .control
                input.input(type="date", v-model="fechaFin")
          .field.pt-20px
            .control.flex.jcc
              button.button.is-primary(type="button", @click="submitForm")
                span.icon.is-small
                  i.fa.fa-save
                span Guardar
        .message.is-warning(v-if="estoySiendoReemplazado")
          .message-body Ya estas siendo reemplazado por&nbsp;
            strong {{ nombreReemplazo }}
</template>

<script>
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado.vue'
import { apiPost, notify } from '../util/general';
import moment from 'moment';
export default {
  name: 'Component_Asignar_Delegaciones',
  components: {
    LookupSmallEmpleado
  },
  data () {
    return {
      fechaInicio: moment().format('YYYY-MM-DD'),
      fechaFin: moment().add(1, 'month').format('YYYY-MM-DD'),
      mostrarBusquedaReemplazante: false,
      codigoReemplazante: ''
    };
  },
  computed: {
    estoySiendoReemplazado () {
      return this.$store.getters.estoySiendoReemplazado
    },
    nombreReemplazo () {
      return this.$store.getters.nombreReemplazo
    }
  },
  methods: {
    submitForm () {
      var vm = this;
      const data = {
        codigoEmpleadoReemplazante: vm.codigoReemplazante,
        fechaInicio: vm.fechaInicio,
        fechaFin: vm.fechaFin
      };
      if (!vm.codigoReemplazante) {
        notify(vm, 'error', 'Error', 'Debe seleccionar un reemplazante');
        return;
      }
      if (!vm.fechaInicio) {
        notify(vm, 'error', 'Error', 'Debe seleccionar una fecha de inicio');
        return;
      }
      if (!vm.fechaFin) {
        notify(vm, 'error', 'Error', 'Debe seleccionar una fecha de fin');
        return;
      }
      apiPost(vm, '/delegaciones', data, function (data) {
        notify(vm, 'success', 'Exito', 'Se ha asignado el reemplazo correctamente');
        vm.$store.dispatch('setEstoySiendoReemplazado', true);
        vm.$store.dispatch('setNombreReemplazo', data.nombreReemplazo);
      }, function (error) {
        notify(vm, 'error', 'Error', error.message);
      });
    },
    seleccionarReemplazante (o) {
      this.codigoReemplazante = o.codigo
    },
    getTodayDate () {
      const today = new Date();
      const year = today.getFullYear();
      let month = today.getMonth() + 1;
      let day = today.getDate();

      // Asegúrate de que el mes y el día tengan dos dígitos
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;

      return `${year}-${month}-${day}`;
    }
  }
};
</script>
<style lang="stylus" scoped>
.contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
  label
    text-align left
  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 90%;
    z-index: 70;
    top 0
  .width-90
    width 90% !important
  .input-container
    display flex
    align-items center
    .input
      flex 1
    .erase-data
      cursor pointer
      margin-left 5px

@media (max-width:660px)
  .contenedor-box

    form
      .fdr
        flex-direction column !important
      .pt-20px
        padding-top 20px !important
</style>



// WEBPACK FOOTER //
// Component_Asignar_Delegaciones.vue?f79e96b8